/* Technichem — hazmat per-box fee sync.
   Keeps the "Hazmat Shipping Fee" line quantity == number of hazmat boxes in cart.
   Hazmat lines identified by product_id membership in window.TC_HAZMAT_IDS. */
(function () {
  var FEE_VARIANT_ID = window.TC_HAZMAT_FEE_VARIANT_ID;
  var HAZMAT_IDS = window.TC_HAZMAT_IDS || [];
  if (!FEE_VARIANT_ID) return;
  var syncing = false;

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addFee(qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(FEE_VARIANT_ID), quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function changeFee(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function onCartPage() { return window.location.pathname.indexOf('/cart') === 0; }

  // One-shot reload guard: at most ONE reload between matched states — infinite loop impossible.
  function reloadOnce() {
    if (!onCartPage()) return;
    if (sessionStorage.getItem('tcHazmatReloaded')) return;
    sessionStorage.setItem('tcHazmatReloaded', '1');
    window.location.reload();
  }

  function sync() {
    if (syncing) return Promise.resolve();
    return getCart().then(function (cart) {
      var boxes = 0, feeQty = 0, feeKey = null;
      cart.items.forEach(function (it) {
        if (String(it.variant_id) === String(FEE_VARIANT_ID)) { feeQty = it.quantity; feeKey = it.key; return; }
        if (HAZMAT_IDS.indexOf(it.product_id) !== -1) { boxes += it.quantity; }
      });

      if (boxes === feeQty) {
        sessionStorage.removeItem('tcHazmatReloaded'); // matched state — clear the guard
        return null;
      }

      syncing = true;
      var op;
      if (feeQty === 0 && boxes > 0) {
        op = addFee(boxes);                 // fee absent -> ADD it (change.js cannot add)
      } else if (boxes === 0 && feeKey) {
        op = changeFee(feeKey, 0);          // no hazmat left -> remove fee
      } else {
        op = changeFee(feeKey || FEE_VARIANT_ID, boxes); // adjust to match
      }
      return op.then(function () { reloadOnce(); })
               .catch(function () {})
               .finally(function () { syncing = false; });
    }).catch(function () { /* never block the storefront */ });
  }

  // Re-sync after any cart mutation (but not our own).
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (CART_RE.test(url) && !syncing) { p.then(function () { setTimeout(sync, 60); }).catch(function () {}); }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (CART_RE.test(url)) {
        this.addEventListener('load', function () { if (!syncing) setTimeout(sync, 60); });
      }
    } catch (e) {}
    return _open.apply(this, arguments);
  };

  if (document.readyState !== 'loading') { sync(); }
  else { document.addEventListener('DOMContentLoaded', sync); }
})();
